import { render, staticRenderFns } from "./unused_comp_HotSale.vue?vue&type=template&id=e23e9358&scoped=true&"
import script from "./unused_comp_HotSale.vue?vue&type=script&lang=js&"
export * from "./unused_comp_HotSale.vue?vue&type=script&lang=js&"
import style0 from "./unused_comp_HotSale.vue?vue&type=style&index=0&id=e23e9358&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23e9358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
